import React from "react";
import { Navigate } from "react-router-dom";

/**
 * PrivateRoute Component
 * Protects routes that require authentication by checking for token in localStorage
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The component to render if authenticated
 * @param {string} props.redirectTo - Optional redirect path (defaults to "/")
 * @returns {React.ReactNode} - Either the protected component or redirect to login
 */
const PrivateRoute = ({ children, redirectTo = "/" }) => {
  // Check for token in localStorage
  const token = localStorage.getItem("token");

  // If token exists, render the protected component
  if (token) {
    return <>{children}</>;
  }

  // If no token, redirect to the specified route (default: home page)
  return <Navigate to={redirectTo} replace />;
};

export default PrivateRoute;
